import { createFileRoute } from "@tanstack/react-router";
import HowDoDoctorsDecide from "@/pages/articles/HowDoDoctorsDecide";
export const Route = createFileRoute(
  "/how-do-doctors-decide-which-depression-treatment-to-recommend",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Doctors Decide Depression Treatment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How do psychiatrists choose between TMS, SAINT TMS, SPRAVATO, and medication? Learn how treatment decisions are made in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "How Doctors Decide Depression Treatment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How do psychiatrists choose between TMS, SAINT TMS, SPRAVATO, and medication? Learn how treatment decisions are made in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-do-doctors-decide-which-depression-treatment-to-recommend",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-do-doctors-decide-which-depression-treatment-to-recommend",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowDoDoctorsDecide />;
}
